export const YOUTUBE_VIDEO_IDS = {
    agentIntro: 'XvrCv70TgcI',
    agentScore: '62EKNL6ofmw',
    superscaleDeepDive: 'vl6dvW_UJQM',
    superscaleOverview: 'lAXguWeiTUk',
    superscaleUsecases: 'NiSlqippYKU',
    gettingStarted: 'cb79FYa17R8',
    brandLogoConsistency: 'Y4OGBsu4Cec',
    contextFiles: 'hsw02vP-qBQ',
    editStaticAds: '6KUecmuCYNU',
} as const

export const AGENT_INTRO_VIDEO_ID = YOUTUBE_VIDEO_IDS.agentIntro
export const AGENT_SCORE_VIDEO_ID = YOUTUBE_VIDEO_IDS.agentScore

export const getYouTubeWatchUrl = (videoId: string) => `https://www.youtube.com/watch?v=${videoId}`
